import isReadingPaneVisible from 'owa-mail-store/lib/store/selectors/isReadingPaneVisible';
import { getListViewStore } from '../store/Store';

/**
 *  Tells whether we are in search list view or not
 */
export const isInSearchView = (): boolean =>
    !isReadingPaneVisible() && getListViewStore().shouldShowSearchBox;
